// eslint-disable-next-line
export const TEALIUM_CONFIG = {
    // eslint-disable-next-line
    script_url: '//tags.tiqcdn.com/utag/totalms/ms-eur-digitalplatforms-wf/prod/utag.js',
    // eslint-disable-next-line
    default_data: {
        // eslint-disable-next-line
        site_name: '644567',
        // eslint-disable-next-line
        language: 'english'
    }
}

// eslint-disable-next-line
export const GA_CONFIG = {
    // eslint-disable-next-line
    measurement_id: 'G-X5LNV6R47Q',
    // eslint-disable-next-line
    default_data: {
        language: 'english'
    },
    consent: {
        // eslint-disable-next-line
        ad_storage: 'granted',
        // eslint-disable-next-line
        ad_user_data: 'granted',
        // eslint-disable-next-line
        ad_personalization: 'granted',
        // eslint-disable-next-line
        analytics_storage: 'granted',
        // eslint-disable-next-line
        ads_data_redaction: true
    }
}

// eslint-disable-next-line
export const PAGE_TRACKING_DATA = {
    home: {
        // eslint-disable-next-line
        page_name: 'COCKPIT - Home',
        // eslint-disable-next-line
        page_url: 'https://cockpit.digitalplatforms.totalenergies.com'
    },
    lz: {
        list: {
            // eslint-disable-next-line
            page_name: 'COCKPIT - Landing-Zones',
            // eslint-disable-next-line
            page_url: 'https://cockpit.digitalplatforms.totalenergies.com/#/landing-zones'
        },
        details: {
            // eslint-disable-next-line
            page_name: 'COCKPIT - Landing-Zones - {{lzName}}',
            // eslint-disable-next-line
            page_url: 'https://cockpit.digitalplatforms.totalenergies.com/#/landing-zones/{{lzName}}/tags'
        },
        firewallMigration: {
            // eslint-disable-next-line
            page_name: 'COCKPIT - Landing-Zones - {{lzName}} - Firewall Migration',
            // eslint-disable-next-line
            page_url: 'https://cockpit.digitalplatforms.totalenergies.com/#/landing-zones/{{lzName}}/firewall-migration'
        },
        logs: {
            firewall: {
                // eslint-disable-next-line
                page_name: 'COCKPIT - Logs - Firewall',
                // eslint-disable-next-line
                page_url: 'https://cockpit.digitalplatforms.totalenergies.com/#/logs/firewall'
            },
            flow: {
                // eslint-disable-next-line
                page_name: 'COCKPIT - Logs - Flow',
                // eslint-disable-next-line
                page_url: 'https://cockpit.digitalplatforms.totalenergies.com/#/logs/flow'
            }
        }
    }
}